// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".job-lang-skill__level-icon[data-v-3d2046d0]{--text-opacity:1;color:#e9e9e9;color:rgba(233,233,233,var(--text-opacity));width:1em;height:1em}.job-lang-skill__level-icon.job-lang-skill__level-icon--active[data-v-3d2046d0]{--text-opacity:1;color:#fddb5c;color:rgba(253,219,92,var(--text-opacity))}.job-lang-skill__level-icon[data-v-3d2046d0]:not(:first-child){margin-left:.75em}", ""]);
// Exports
module.exports = exports;
